const appcues = {
    identify(user) {
        if (!user) {
            return;
        }

        if (window.Appcues) {
            window.Appcues.identify(
                user._id, // unique, required
                {
                    // recommended (optional) properties
                    daysToTrialEnd: user.trialEnd, // trialing?
                    role: user.teamRole.role, // current user’s role
                    team: user.teamRole.team, // current user's account ID
                    companyName: user.teamSettings.name,
                    email: user.username, // current user's first name
                    firstName: user.firstname,
                    lang: user.lang, // current users's language
                    createdAt: parseInt(user.createdAt),
                },
            );
        }
    },
};

export default appcues;
